var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg63(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "77") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-day",
    transform: "translate(-3984.000000, -6.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(25.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 77,
    transform: "translate(3960.499429, 7.499429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0812227,4.89813333 C26.4107749,4.89813333 28.4680403,6.31589281 29.3153031,8.41731163 L29.3985963,8.63710842 L29.664,9.387 L20.2279384,9.38784762 L17.833,17.893 L16.5602889,17.893181 C14.7552768,17.893181 13.2949333,16.439235 13.2949333,14.6480177 C13.2949333,12.9186629 14.6560203,11.5035342 16.3748998,11.4079954 L16.5603889,11.4028544 L18.3478077,11.4028544 L18.4637635,10.0293778 C18.7072707,7.14097859 21.1446418,4.89813333 24.0812227,4.89813333 Z M14.4814811,-6.66133815e-16 C17.3400515,-8.8817842e-16 19.9123894,1.55416583 21.270856,3.97100555 C18.9844551,4.94746422 17.3133825,7.07913321 16.9981823,9.6286932 L16.9696329,9.90342583 L16.5602889,9.90342583 C13.928092,9.90342583 11.7955048,12.0276163 11.7955048,14.6480177 C11.7955048,15.8199102 12.2220092,16.8923963 12.9288511,17.7200774 L13.0845548,17.8936376 L4.69850941,17.893181 C2.10319848,17.893181 4.99400521e-12,15.7901824 4.99400521e-12,13.1949714 C4.99400521e-12,10.672044 1.98788247,8.61398575 4.4833993,8.50159588 L4.69850941,8.4967619 L6.60968107,8.4967619 L6.7250371,7.12278552 C7.06190872,3.11111436 10.4287256,-6.66133815e-16 14.4814811,-6.66133815e-16 Z M31.6990196,9.56625432 C34.0130377,9.56625432 35.8863238,11.4316434 35.8863238,13.7297676 C35.8863238,15.9580578 34.12485,17.7797239 31.9081309,17.8880817 L31.6990196,17.893181 L30.882,17.893 L32.3975815,15.3746897 L27.1756789,15.3746897 L29.745,9.614 L29.8145378,9.80846202 L31.0427697,9.61683505 C31.2579877,9.58324785 31.4771042,9.56625432 31.6990196,9.56625432 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FED100",
    points: "23.2981393 20.3746897 18.6928762 20.3746897 21.3639288 10.8878476 27.5349815 10.8878476 24.8639288 16.8746897 29.7455078 16.8746897 20.719192 31.8878476"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg63);
export default __webpack_public_path__ + "static/media/63.2ae40ff17245e9488e563fedc5570da0.svg";
export { ForwardRef as ReactComponent };